export default "__VITE_ASSET__c12379e5__"